var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmClogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0 0 L 257.5 0 L 258 0.5 L 258 80 L 0.5 80 L 0 79.5 L 0 42 Q 4.1 43.3 3 40 L 0 39.5 L 0 0 Z M 40 3 L 40 9 L 36 9 L 36 15 L 32 15 L 32 22 L 28 22 L 28 28 L 23 28 L 23 23 L 18 23 L 18 19 L 11 19 L 11 17 Q 10 14 6 15 Q 3 16 4 21 Q 5 23 10 22 L 11 22 L 11 25 L 18 25 L 18 30 L 23 30 Q 25 36 19 34 L 19 40 Q 12 42 14 36 L 9 36 Q 7 44 14 41 Q 16 47 11 45 L 11 50 L 6 50 L 6 57 L 13 57 L 13 62 L 18 62 L 18 65 L 23 65 Q 22 69 25 70 Q 32 68 30 74 L 37 74 L 37 78 L 43 78 Q 45 77 44 73 Q 43 70 39 71 L 37 72 L 37 67 L 30 67 L 30 64 L 24 64 L 24 59 L 18 59 Q 20 53 13 55 Q 11 49 17 51 L 17 46 L 21 46 L 21 40 L 25 40 L 25 34 Q 31 32 29 38 L 35 38 L 35 42 L 41 42 Q 39 48 46 46 L 46 50 L 54 50 Q 52 58 59 55 L 59 48 Q 52 50 54 44 L 48 44 Q 47 39 50 40 L 50 34 L 46 34 L 46 40 Q 40 42 42 37 Q 41 34 37 35 L 35 36 L 35 32 L 30 32 Q 28 26 33 28 L 33 22 Q 39 21 39 24 L 44 24 L 44 20 L 38 20 L 38 15 Q 45 13 43 19 Q 47 20 48 18 L 48 14 L 53 14 L 53 13 L 54 13 Q 52 19 58 17 L 59 17 L 59 21 L 64 21 L 65 24 L 71 24 L 71 29 L 77 29 L 77 23 L 71 23 L 71 19 L 64 19 Q 66 13 59 15 L 59 10 L 54 10 L 54 7 L 46 7 L 46 3 L 40 3 Z M 49 19 Q 47 25 53 23 Q 55 17 49 19 Z M 55 23 Q 54 28 58 26 Q 60 22 55 23 Z M 45 24 Q 43 30 48 28 Q 50 22 45 24 Z M 8 26 Q 6 32 13 30 Q 15 24 8 26 Z M 34 26 Q 32 33 38 31 Q 40 24 34 26 Z M 86 27 L 86 68 L 102 68 L 102 63 L 92 63 L 92 50 L 101 50 L 101 44 L 94 44 L 92 45 L 92 32 L 102 32 L 102 27 L 86 27 Z M 139 27 L 137 29 L 137 68 L 156 68 L 156 54 L 149 54 L 149 62 L 150 63 L 143 63 L 144 62 L 144 34 L 144 32 L 150 33 L 149 34 L 149 41 L 156 41 L 156 29 L 155 27 L 139 27 Z M 62 28 Q 61 31 64 30 Q 65 27 62 28 Z M 14 30 Q 12 36 18 34 Q 20 28 14 30 Z M 52 30 Q 51 33 54 32 Q 55 29 52 30 Z M 40 32 Q 39 36 44 34 Q 45 30 40 32 Z M 68 32 Q 67 35 70 34 Q 71 31 68 32 Z M 231 32 L 231 38 L 236 38 L 236 32 L 231 32 Z M 4 33 Q 2 38 8 36 Q 10 31 4 33 Z M 201 33 L 201 42 L 198 42 L 198 46 L 201 47 L 201 67 L 203 68 L 210 68 Q 212 62 207 64 L 207 63 L 207 48 L 206 47 L 210 46 Q 212 40 206 42 Q 208 40 207 35 Q 206 32 201 33 Z M 57 34 Q 56 37 59 36 Q 60 33 57 34 Z M 63 38 Q 62 41 66 40 Q 67 37 63 38 Z M 53 40 Q 52 45 56 43 Q 58 39 53 40 Z M 106 42 L 106 68 L 111 68 L 111 47 L 117 47 L 117 48 L 117 68 L 122 68 L 122 47 L 128 47 L 128 68 L 133 68 L 133 45 L 132 42 L 125 42 L 124 43 L 120 42 Q 114 41 113 43 L 106 42 Z M 163 42 L 160 45 L 160 66 L 161 67 L 162 68 L 175 68 L 176 67 L 176 59 Q 169 57 171 64 L 165 64 L 165 57 L 175 57 L 176 56 L 176 44 L 175 42 L 163 42 Z M 180 42 L 180 68 L 185 68 L 185 48 Q 185 46 190 47 L 191 47 L 191 68 L 196 68 L 196 44 L 195 42 L 187 42 L 186 43 L 180 42 Z M 213 42 L 213 68 Q 213 68 218 68 L 219 67 L 219 49 L 219 47 L 223 47 L 223 52 L 228 52 L 228 44 L 227 42 Q 220 40 219 43 L 213 42 Z M 231 42 L 231 68 L 236 68 L 236 43 L 231 42 Z M 239 42 L 244 54 L 244 57 L 239 66 L 239 68 L 244 68 L 248 60 L 250 66 L 250 68 L 255 68 L 255 65 L 250 55 L 255 46 L 255 42 L 250 42 L 248 49 L 245 44 Q 244 41 239 42 Z M 5 43 Q 3 49 10 47 Q 12 41 5 43 Z M 59 43 Q 57 49 63 47 Q 65 41 59 43 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 43 9 L 46 9 L 46 14 L 43 14 L 43 9 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 165 46 L 171 46 L 171 52 L 165 52 L 165 46 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 43 14 L 48 14 L 48 17.5 Q 46.8 20 43 19 L 43 14 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 49 19 Q 55 17 53 23 Q 47 25 49 19 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 38 20 L 44 20 L 44 24 L 38 24 L 38 20 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 55 23 Q 59.5 21.5 58 26 Q 53.5 27.5 55 23 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 45 24 Q 49.9 22.4 48 28 Q 43.1 29.6 45 24 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 8 26 Q 15.1 23.6 13 30 Q 5.9 32.4 8 26 Z "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 34 26 Q 40.4 23.9 38 31 Q 31.6 33.1 34 26 Z "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 24.5 28 Q 31.8 25.4 30 31.5 Q 29.5 34.5 25.5 34 L 23 33.5 Q 22 29 24.5 28 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 62 28 Q 65 27 64 30 Q 61 31 62 28 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 14 30 Q 20 28 18 34 Q 12 36 14 30 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 52 30 Q 55 29 54 32 Q 51 33 52 30 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 40 32 Q 45.2 30.3 44 34 Q 38.8 35.7 40 32 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 68 32 Q 71 31 70 34 Q 67 35 68 32 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 4 33 Q 9.6 31.1 8 36 Q 2.4 37.9 4 33 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 46 34 L 50 34 L 50 40 L 46 40 L 46 34 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 57 34 Q 60 33 59 36 Q 56 37 57 34 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 9 36 Q 16.5 33.5 14 41 Q 6.5 43.5 9 36 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 63 38 Q 67.1 36.7 66 40 Q 61.9 41.3 63 38 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 0 40 Q 4.1 38.7 3 42 Q -1.1 43.3 0 40 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 53 40 Q 57.5 38.5 56 43 Q 51.5 44.5 53 40 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 5 43 Q 12.1 40.6 10 47 Q 2.9 49.4 5 43 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(171,166,162)",
    stroke: "rgb(171,166,162)",
    strokeWidth: 1,
    opacity: 0.8862745098039215,
    d: "M 59 43 Q 65 41 63 47 Q 57 49 59 43 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 48.5 7 Q 53.3 6.3 54 9.5 L 54.5 11 L 56.5 10 Q 59.5 10.5 59 14.5 L 55.5 17 Q 52.9 15.6 53.5 11 L 49.5 14 L 46 12 Q 45.3 8.2 48.5 7 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 6.5 15 Q 10.5 14.5 11 17.5 L 7.5 22 L 4 20 Q 3.3 16.2 6.5 15 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 60.5 15 Q 66.2 13.2 64 19.5 L 65.5 19 Q 70 18 71 20.5 Q 69.7 25.1 75.5 23 L 77 26.5 Q 76.5 29.5 72.5 29 Q 69.9 27.6 70.5 23 L 65.5 24 L 63.5 20 L 60.5 21 Q 58.3 20.3 59 16.5 L 60.5 15 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 12 19 Q 16.7 18 18 21.5 L 15.5 25 Q 11.8 25.8 11 23.5 L 12 19 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 19.5 23 L 23 24.5 Q 24 29 21.5 30 L 18 28.5 Q 17 24 19.5 23 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 29 32 Q 33.6 30.8 35 33.5 Q 35.5 37.5 32.5 38 L 29 35.5 L 29 32 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 233.5 32 L 235 32 L 235 37 Q 230.5 38.8 232 33.5 L 233.5 32 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 202 34 L 205 34 L 205 41.5 Q 206.2 44 210 43 L 210 45 L 205 45.5 L 205 65 L 210 65 L 210 67 L 203.5 67 L 202 65.5 L 202 45.5 L 199 45 L 199 43 L 202 41.5 L 202 34 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 37 35 L 42 38.5 L 39.5 42 L 35 41 L 37 35 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 43.5 40 Q 47.5 39.5 48 42.5 Q 47.2 45.1 50.5 44 L 54 46.5 L 51.5 50 Q 46.8 50.8 46 47.5 Q 46.8 44.9 43.5 46 L 41 42.5 L 43.5 40 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 107 43 L 112.5 44 Q 114 41.5 119.5 43 L 123.5 44 Q 125 41.5 130.5 43 L 132 44.5 L 132 67 L 129 66.5 L 129 46 L 122.5 46 L 121 47.5 L 121 67 L 118 66.5 L 118 46 L 111.5 46 L 110 47.5 L 110 67 L 107 66.5 L 107 43 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 162.5 43 L 173.5 43 L 175 44.5 L 175 54.5 L 173.5 56 L 164 56 L 164 63.5 Q 165.9 66.8 172 65 Q 171 61.2 173.5 60 Q 176.3 59.4 175 65.5 L 173.5 67 L 162.5 67 L 161 65.5 L 161 44.5 L 162.5 43 Z M 164 45 L 164 53 L 172 53 L 172 45 L 164 45 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 181 43 L 185.5 44 Q 187.3 41.3 193.5 43 L 195 44.5 L 195 67 L 192 66.5 L 192 46.5 Q 190.8 43.8 189.5 46 L 184 46 L 184 66.5 L 181 67 L 181 43 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 214 43 L 218.5 44 Q 220 41.5 225.5 43 L 227 44.5 L 227 51 L 224 51 L 224 45.5 L 222.5 45 L 217 47.5 L 217 66.5 L 214 67 L 214 43 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 232 43 L 235 43.5 L 235 67 L 232 66.5 L 232 43 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 240.5 43 Q 245.3 41.3 244 45.5 L 246 51 Q 248.7 52.1 248 49.5 L 251.5 43 L 254 43.5 L 249 55.5 L 255 66.5 L 251 67 L 247.5 58 L 242.5 67 Q 239.2 68.1 240 65.5 L 245 56.5 L 245 52.5 L 240.5 43 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 55.5 48 L 59 49.5 Q 60 54 57.5 55 Q 54.2 56.1 55 53.5 L 54 49.5 L 55.5 48 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 14.5 55 L 18 56.5 Q 18.8 61.3 15.5 62 L 13 61 Q 11.8 56.4 14.5 55 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 20.5 59 L 24 60.5 Q 24.8 64.3 22.5 65 Q 18.8 65.8 18 63.5 Q 17.5 59.5 20.5 59 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 25.5 64 Q 29.3 63.3 30 65.5 Q 30.5 69.5 27.5 70 L 23 68 L 25.5 64 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 32.5 67 Q 36.5 66.5 37 69.5 Q 37.5 73.5 34.5 74 Q 30.5 74.5 30 71.5 Q 29.5 67.5 32.5 67 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,91,153)",
    stroke: "rgb(44,91,153)",
    strokeWidth: 1,
    opacity: 0.9411764705882353,
    d: "M 39.5 71 L 44 74.5 Q 44.8 76.8 42.5 76 L 39.5 78 Q 36.5 77.5 37 73.5 L 39.5 71 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,255)",
    stroke: "rgb(0,0,255)",
    strokeWidth: 1,
    opacity: 0.00392156862745098,
    d: "M 206.5 34 L 207 39.5 L 206 39.5 L 206.5 34 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,255)",
    stroke: "rgb(0,0,255)",
    strokeWidth: 1,
    opacity: 0.00392156862745098,
    d: "M 206.5 47 L 207 62.5 L 206 62.5 L 206.5 47 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,255)",
    stroke: "rgb(0,0,255)",
    strokeWidth: 1,
    opacity: 0.00392156862745098,
    d: "M 218.5 48 L 219 66.5 L 218 66.5 L 218.5 48 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,114,183)",
    stroke: "rgb(30,114,183)",
    strokeWidth: 1,
    opacity: 0.9137254901960784,
    d: "M 41.5 3 Q 45.3 2.3 46 4.5 Q 46.8 8.3 44.5 9 L 40 8 Q 39 4.2 41.5 3 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,114,183)",
    stroke: "rgb(30,114,183)",
    strokeWidth: 1,
    opacity: 0.9137254901960784,
    d: "M 37.5 9 Q 42.3 8.3 43 11.5 L 40.5 15 L 37 15.5 L 38 19.5 L 34.5 22 Q 31.5 21.5 32 17.5 L 33 15 L 37 14.5 L 36 10.5 L 37.5 9 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,114,183)",
    stroke: "rgb(30,114,183)",
    strokeWidth: 1,
    opacity: 0.9137254901960784,
    d: "M 28 22 L 33 22 L 33 25.5 L 29.5 28 Q 26.8 26.6 28 22 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,114,183)",
    stroke: "rgb(30,114,183)",
    strokeWidth: 1,
    opacity: 0.9137254901960784,
    d: "M 86 27 L 100.5 27 L 101 31 L 92.5 31 L 91 32.5 L 92 33.5 L 92 45 L 100 45 L 100 49 L 92 49 L 92 64 L 101 64 L 101 68 L 86 68 L 86 27 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,114,183)",
    stroke: "rgb(30,114,183)",
    strokeWidth: 1,
    opacity: 0.9137254901960784,
    d: "M 139.5 27 L 153.5 27 L 155 28.5 L 155 40 L 150 40 L 150 31 L 143 31 L 143 63.5 L 143.5 64 L 150 64 L 150 55 L 155 55 L 155 66.5 L 153.5 68 L 139.5 68 L 138 66.5 L 138 28.5 L 139.5 27 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,114,183)",
    stroke: "rgb(30,114,183)",
    strokeWidth: 1,
    opacity: 0.9137254901960784,
    d: "M 20.5 34 Q 24.3 33.3 25 35.5 Q 25.8 39.3 23.5 40 L 20 40.5 L 21 43.5 L 16 46.5 L 17 48.5 Q 16.5 51.5 12.5 51 Q 10.3 50.3 11 46.5 L 15 44.5 L 14 41.5 Q 15.4 38.9 20 39.5 L 19 35.5 L 20.5 34 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,114,183)",
    stroke: "rgb(30,114,183)",
    strokeWidth: 1,
    opacity: 0.9137254901960784,
    d: "M 8.5 50 L 13 52 L 13 56 L 11.5 56 L 7.5 57 Q 5.3 56.3 6 52.5 L 8.5 50 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 46.5 7 L 48 7.5 L 45.5 9 L 46.5 7 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 52.5 7 Q 54.8 6.3 54 8.5 L 52.5 7 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 40.5 8 L 43 9.5 L 42.5 11 L 40.5 8 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 54.5 10 L 51.5 14 L 54.5 10 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 57.5 10 Q 59.8 9.3 59 11.5 L 57.5 10 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 46 12 L 49 13.5 L 46 14 L 46 12 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 42.5 13 L 43 15 L 41 14.5 L 42.5 13 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 36.5 14 L 37.5 16 L 36.5 14 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 5.5 15 L 4.5 17 L 5.5 15 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 9.5 15 L 10.5 17 L 9.5 15 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 58.5 15 L 60 15.5 L 57.5 17 L 58.5 15 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 10.5 19 Q 13.1 18.3 12 21 L 8.5 22 L 10.5 19 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 16.5 19 Q 18.8 18.3 18 20.5 L 16.5 19 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 64.5 19 L 63.5 21 L 64.5 19 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 4.5 20 L 7 21.5 L 5.5 22 L 4.5 20 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 32.5 20 L 33.5 22 Q 30.7 22.7 32.5 20 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 37.5 20 L 36.5 22 L 37.5 20 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 17.5 22 L 18.5 24 L 16.5 25 L 17 23.5 L 17.5 22 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 32.5 26 L 33 28 L 31 27.5 L 32.5 26 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 76.5 27 L 75.5 29 L 76.5 27 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 101.5 27 L 102 32 L 92.5 32 L 91.5 33 L 92.5 31 L 101 31 L 101.5 27 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 138.5 27 L 138 28.5 L 138 66.5 L 139 67.5 L 137 68 L 137 28.5 L 138.5 27 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 154.5 27 L 156 28.5 L 156 41 L 149 41 L 149 33.5 L 150 33.5 L 150 40 L 155 40 L 155 28.5 L 154.5 27 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 23.5 28 L 22.5 30 L 23.5 28 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 143.5 31 L 150 31.5 L 143.5 32 L 143.5 31 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 231 32 L 233 32.5 L 232 37 Q 236.9 38.8 235 32.5 L 236 32.5 Q 238.5 40.8 231 38 L 231 32 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 143.5 33 L 144 61.5 L 143 61.5 L 143.5 33 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 201 33 L 206 33 L 206 42 L 209.5 42 L 209.5 43 Q 205.8 43.8 205 41.5 L 205 34 L 202 34 L 202 41.5 L 200.5 43 Q 197.9 42.3 199 45 L 202 45.5 L 202 65.5 L 203.5 67 L 210 67.5 L 202.5 68 L 201 66.5 L 201 46 Q 196.1 47.6 198 42 L 201 42 L 201 33 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 36.5 35 L 37 36.5 L 33.5 38 L 34.5 36 L 36.5 35 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 39.5 35 L 42 36.5 L 41.5 38 L 39.5 35 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 29.5 36 L 30.5 38 Q 27.7 38.7 29.5 36 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 19.5 39 L 20.5 41 L 19.5 39 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 41.5 39 Q 44.5 40.5 41.5 42 L 40 41.5 L 41.5 39 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 46.5 40 Q 48.8 39.3 48 41.5 L 46.5 40 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 106 42 L 112.5 43 Q 114 40.5 119.5 42 L 123.5 43 L 124.5 42 L 132 42 L 133 44.5 L 133 68 L 128 67.5 L 128 47 L 122 47 L 122 67.5 L 117 68 L 117 47.5 L 116.5 47 L 111 47 L 111 67.5 L 106 68 L 106 42 Z M 107 43 L 107 67 L 110 67 L 110 48 L 112 46 L 118 46 L 118 67 L 121 67 L 121 48 L 123 46 L 129 46 L 129 67 L 132 67 L 132 45 L 131 43 Q 125 42 124 44 L 120 43 Q 114 42 113 44 L 107 43 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 162.5 42 L 174.5 42 L 176 43.5 L 176 55.5 L 174.5 57 L 165 57 L 165 64 L 171 64 Q 168.5 56.5 176 59 L 176 66.5 L 174.5 68 L 161.5 68 L 161 66.5 L 160 65.5 L 160 44.5 L 162.5 42 Z M 163 43 L 161 45 L 161 66 L 163 67 L 174 67 L 175 66 Q 176 59 174 60 Q 171 61 172 65 Q 166 67 164 64 L 164 56 L 174 56 L 175 55 L 175 45 L 174 43 L 163 43 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 180 42 Q 184.6 40.8 186 43.5 L 184.5 44 L 181 43 L 181 66.5 L 184 67 L 184 46.5 Q 184.1 45.4 189.5 46 Q 190.8 43.8 192 46.5 L 192 66.5 L 195 67 L 195 44.5 L 193.5 43 L 187 42.5 L 194.5 42 L 196 43.5 L 196 68 L 191 67.5 L 191 46.5 L 189.5 47 Q 185 46.5 185 47.5 L 185 68 L 180 68 L 180 42 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 213 42 Q 217.6 40.8 219 43.5 L 217.5 43 L 214 43.5 L 214 67 L 217 66.5 L 217 47.5 L 224 45 L 224 51 L 227 51 Q 228.7 44.9 225.5 43 L 220 42.5 L 226.5 42 L 228 43.5 L 228 52 Q 220.5 54.8 223 46.5 L 221.5 47 L 218 47.5 L 218 68 L 213 68 L 213 42 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 231 42 L 236 42.5 L 236 68 L 231 67.5 L 231 42 Z M 232 43 L 232 67 L 235 67 L 235 44 L 232 43 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 239 42 Q 243.6 40.8 245 43.5 L 247.5 49 L 248.5 47 L 249 48.5 L 248 51 Q 245 52.3 246 48.5 L 244 43 L 240 43.5 L 245 52.5 L 245 56.5 L 240 67 L 244 65.5 L 247.5 58 L 248 59.5 L 244 68 L 239 68 L 239 65.5 L 244 56.5 L 244 53.5 L 239 42 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 250 42 L 255 42 L 255 45.5 L 250 54.5 L 255 65.5 L 253 64.5 L 249 53.5 L 254 43.5 L 251.5 43 L 250 43.5 L 250 42 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 20.5 44 L 21 46 L 19 45.5 L 20.5 44 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 41.5 44 L 42.5 46 Q 39.7 46.7 41.5 44 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 51.5 44 L 54 45.5 L 52.5 45 L 51.5 44 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 93.5 44 L 101 44 L 101 50 L 92 49.5 L 100 49 L 100 45 L 93.5 45 L 93.5 44 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 164 45 L 172 45 L 172 53 L 164 53 L 164 45 Z M 165 46 L 165 52 L 171 52 L 171 46 L 165 46 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 205 45 L 210 45.5 L 206 46 L 206 63.5 L 209.5 64 L 209.5 65 Q 205 65.5 205 64.5 L 205 45 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 46.5 48 L 47.5 50 Q 44.7 50.7 46.5 48 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 53.5 48 L 55 48.5 L 52.5 50 L 53.5 48 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 16.5 49 L 17 51 L 15 50.5 L 16.5 49 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 6 50 L 8 50.5 L 6 51.5 L 6 50 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 10.5 50 L 13 51.5 L 11.5 52 L 10.5 50 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 149 54 L 156 54 L 156 68 L 154 67.5 L 155 66.5 L 155 55 L 150 55 L 150 61.5 L 149 61.5 L 149 54 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 13.5 55 L 12.5 57 L 11 56.5 L 13.5 55 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 18.5 59 L 20 59.5 L 16.5 62 L 18.5 59 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 248.5 61 L 251 67 L 255 67.5 L 250 68 L 248.5 61 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 92.5 63 L 102 63 L 102 67.5 L 101 67.5 L 101 64 L 92.5 64 L 92.5 63 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 143.5 63 L 150 63.5 L 143.5 64 L 143.5 63 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 23 64 L 25 64.5 L 23 65.5 L 23 64 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 30.5 67 L 32 67.5 L 28.5 70 L 30.5 67 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 35.5 67 Q 37.8 66.3 37 68.5 L 35.5 67 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 23.5 68 L 26 69.5 L 24.5 70 L 23.5 68 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 38.5 71 L 36.5 74 L 35 73.5 L 38.5 71 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 41.5 71 L 44 72.5 L 43.5 74 L 41.5 71 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 30.5 72 L 31.5 74 Q 28.7 74.7 30.5 72 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 37.5 76 L 38.5 78 Q 35.7 78.7 37.5 76 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,99,160)",
    stroke: "rgb(46,99,160)",
    strokeWidth: 1,
    opacity: 0.29411764705882354,
    d: "M 42.5 76 L 44 76.5 L 41.5 78 L 42.5 76 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmClogo);
export default __webpack_public_path__ + "static/media/EMClogo.06181218cb480d18738a231abf375a56.svg";
export { ForwardRef as ReactComponent };